import loadingImg from "../assets/loading.svg";
//判断组件中是否已存在div
function isExists(el) {
  return el.querySelector("img[data-role=loading]");
}
function createImg() {
  const img = document.createElement("img");
  img.src = loadingImg;
  img.dataset.role = "loading";
  return img;
}
export default {
  bind(el, bindding) {
    if ((el, bindding)) {
      const img = createImg();
      if (bindding.value) {
        if (isExists(el)) {
          return;
        }
        img.style.position = "absolute";
        img.style.display = "block";
        img.style.top = `50%`;
        img.style.left = `50%`;
        img.style.transform = `translate(-50%,-50%)`;
        img.style.zIndex = "999";
        el.appendChild(img);
      }
    }
  },
  update(el, bindding) {
    if (bindding.value) {
      const img = createImg();
      if (bindding.value) {
        if (isExists(el)) {
          return;
        }
        img.style.position = "absolute";
        img.style.display = "block";
        img.style.top = `50%`;
        img.style.left = `50%`;
        img.style.transform = `translate(-50%,-50%)`;
        img.style.zIndex = "999";
        el.appendChild(img);
      }
    } else {
      const img = el.querySelector("img[data-role=loading]");
      if (img) {
        img.remove();
      }
    }
  },
};

// function (el, bingding) {
//   if (el && bingding) {
//     const img = createImg();
//     if (bingding.value) {
//       if (isExists(el)) {
//         return;
//       }
//       img.className = "abc";
//       img.style.position = "absolute";
//       img.style.display = "block";
// img.style.top = `50%`;
// img.style.left = `50%`;
// img.style.transform = `translate(-50%,-50%)`;
//       el.appendChild(img);
//     } else {
//       // img.remove()
//       console.log("need remove");
//     }
//   }
//   return;
// }
